import { render, staticRenderFns } from "./TagsComboBoxItem.vue?vue&type=template&id=5aa76172&scoped=true&"
import script from "./TagsComboBoxItem.vue?vue&type=script&lang=ts&"
export * from "./TagsComboBoxItem.vue?vue&type=script&lang=ts&"
import style0 from "./TagsComboBoxItem.vue?vue&type=style&index=0&id=5aa76172&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa76172",
  null
  
)

export default component.exports